module.exports = __webpack_public_path__ + "img/P29-zh.0ff99c1c.png";